<p>
  generic-message-modal works!
</p>
